import { createStyles } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import { UnstyledNextLink } from '~/components/shared/UnstyledNextLink/UnstyledNextLink';

const useStyles = createStyles((_, { width }: { width?: number }) => ({
  root: { width },
}));


type PicksheetLinkProps = PropsWithChildren<{
  href: string;
  isEnabled?: boolean;
  className?: string;
  width?: number;
  'aria-disabled'?: boolean;
  'data-test-id'?: string;
  $colorInherit?: boolean;
}>;

function PicksheetLink({
  href,
  isEnabled = true,
  children,
  className,
  width,
  'aria-disabled': ariaDisabled,
  'data-test-id': dataTestId,
  $colorInherit,
}: PicksheetLinkProps) {
  const { classes, cx } = useStyles({ width });

  if (!isEnabled)
    return (
      <div className={cx(classes.root, className)} data-test-id={dataTestId}>
        {children}
      </div>
    );

  return (
    <UnstyledNextLink
      href={href}
      className={cx(classes.root, className)}
      aria-disabled={ariaDisabled}
      data-test-id={dataTestId}
      $colorInherit={$colorInherit}
    >
      {children}
    </UnstyledNextLink>
  );
}

export default PicksheetLink;
